// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/settings/team-member-reporting-roles',
        component: () =>
            import('@/pages/[organisation]/settings/team-member-reporting-roles.vue'),
        name: 'settings.team-member-reporting-roles.search-team-member-reporting-roles',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-reporting-roles.view-team-member-reporting-roles',
        },
    },

    {
        path: '/:organisation/settings/team-member-reporting-roles/new',
        component: () =>
            import('@/pages/[organisation]/settings/team-member-reporting-roles/new.vue'),
        name: 'settings.team-member-reporting-roles.create-team-member-reporting-role',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-reporting-roles.create-team-member-reporting-role',
        },
    },
    {
        path: '/:organisation/settings/team-member-reporting-roles/:id',
        component: () =>
            import('@/pages/[organisation]/settings/team-member-reporting-roles/[id].vue'),
        name: 'settings.team-member-reporting-roles.view-team-member-reporting-role',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-reporting-roles.view-team-member-reporting-roles',
        },
    },
    {
        path: '/:organisation/settings/team-member-reporting-roles/:id/edit',
        component: () =>
            import('@/pages/[organisation]/settings/team-member-reporting-roles/[id]/edit.vue'),
        name: 'settings.team-member-reporting-roles.update-team-member-reporting-role',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-reporting-roles.update-team-member-reporting-role',
        },
    },
];
